import { render, staticRenderFns } from "./Redirections.vue?vue&type=template&id=09e0220e&"
import script from "./Redirections.vue?vue&type=script&lang=js&"
export * from "./Redirections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports